module.exports = __webpack_public_path__ + "static/img/12.faf2279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/12.png
// module id = aQqV
// module chunks = 0